export default {
    title: "Rendelés a következő nevében",
    model: {
        email: {
            label: "Email",
            placeholder: "Kérjük, töltse ki a felhasználónevet vagy az e-mail címet",
            notFound: "Nem találhatók felhasználók",
            errors: {
                myself: "Az e-mail címnek el kell térnie a megadottól"
            }
        }
    },
    cta: {
        impersonate: {
            cta: "Küldés",
            processing: "Beküldés"
        }
    },
    error: {
        userNotExists: "{email} nem létezik",
        country: {
            default: "Az OI jelenleg nem érhető el a felhasználó országában",
            ALPHA3: ""
        }
    }
}